<template>
  <AddControl />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  
  import AddControl from "@/components/GesCom/Control/AddControl.vue";

  export default defineComponent({
    name: "AddControlPage",
    components: {
      AddControl,
    },
  });
</script>